(function () {
  'use strict';

  function isUserAuthenticated() {
    // Normalize secret field across variants (secret | api_key)
    const hasUser = !!(window.userData && window.userData.email);
    const secretVal = hasUser
      ? (window.userData.secret || window.userData.api_key || '')
      : '';

    if (hasUser && secretVal) {
      return {
        isAuthenticated: true,
        email: window.userData.email,
        source: 'userData',
      };
    } else if (
      window.authSession &&
      window.authSession.isLoggedIn &&
      window.authSession.isLoggedIn()
    ) {
      var currentUser = window.authSession.getCurrentUser();
      return {
        isAuthenticated: true,
        email: currentUser ? currentUser.email : '',
        source: 'authSession',
      };
    } else {
      var userSecret = window.CookieUtils
        ? window.CookieUtils.getCookie('user_secret')
        : null;
      if (userSecret && window.userData && window.userData.email) {
        return {
          isAuthenticated: true,
          email: window.userData.email,
          source: 'user_secret_cookie',
        };
      }
    }
    return { isAuthenticated: false, email: '', source: 'none' };
  }

  window.AuthUtils = {
    isUserAuthenticated: isUserAuthenticated,
  };
})();
